<template>
  <div class="fill-height interpretationArea ma-0" style="position: relative">
    <NavbarTest/>

    <div class="circleOne"></div>
    <!--    <div class="circlefour"></div>-->
    <div class="circleTwo"></div>
    <div class="circleThree"></div>
    <div class="interpretationContent  " :class="report == null && 'fill-height'">
      <div v-if="report == null" class="fill-height">
        <div class="d-flex flex-column justify-space-around text-center fill-height">
          <div>
            <v-progress-circular indeterminate color="#46b1a1"></v-progress-circular>
            <p class="mt-3 font-weight-bold">
              در حال آماده سازی تفسیر تست
            </p>
          </div>
        </div>
      </div>
      <div class="interpretationInner" v-else>
        <template v-if="targetTemplate">
          <component
              @getAiResponse="getAiData"
              :ai_response="ai_response" @registerOrTestPanel="registerOrTestPanel"
              :is="targetTemplate.component"
              :report="report"></component>
        </template>

      </div>
    </div>

    <div v-if="report" class="interpretationCta white text-center">
      <p class="interpretationCta__title">
        نتیجه تست پایان راه نیست؛ شروع خودشناسی و درمان است.
      </p>
      <router-link
          :to="{ name: 'userJourney', params: { lang: journeyLang } }"
          class="interpretationCta__link"
      >
        <v-btn
            color="#46b1a1"
            class="interpretationCta__btn white--text font-weight-bold"
            elevation="0"
            x-large
        >
          رزرو جلسه
        </v-btn>
      </router-link>
    </div>

    <AuthBrandFooter :fixed="false" />

  </div>
</template>

<script>
/*eslint-disable*/
import BeckInterpretation from "@/views/indexes/tests/interpretation/beckInterpretation";
import SclInterpretation from "@/views/indexes/tests/interpretation/sclInterpretation";
import Tpcinterpretation from "@/views/indexes/tests/interpretation/tpcinterpretation";
import StlsInterpretation from "@/views/indexes/tests/interpretation/stlsInterpretation";
import SexualFunctionInterpretation from "@/views/indexes/tests/interpretation/SexualFunctionInterpretation";
import GeneralInterpretation from "@/views/indexes/tests/interpretation/generalInterpretation";
import QolInterpretation from "@/views/indexes/tests/interpretation/QolInterpretation";
import BodyShamingInterpretation from "@/views/indexes/tests/interpretation/bodyShamingInterpretation";
import DisappointmentBeckInterpretation from "@/views/indexes/tests/interpretation/DisappointmentBeckInterpretation";
import NeoInterpretation from "@/views/indexes/tests/interpretation/NeoInterpretation";
import {mapGetters} from "vuex";
import MentalReadinessForChangeInterpretation
  from "@/views/indexes/tests/interpretation/MentalReadinessForChangeInterpretation";
import YEMSQPlusInterpretation from "@/views/indexes/tests/interpretation/YEMSQPlusInterpretation";
import {EventBus} from "@/event-bus";
import NavbarTest from "@/components/Test/NavbarTest";
import AdvanceTestTemplate from "@/views/indexes/tests/interpretation/advanceTestTemplate";
import axios from "axios";
import EventsMixins from "@/mixins/EventsMixins";
import AuthBrandFooter from "@/components/Auth/AuthBrandFooter.vue";

export default {
  components: {
    AuthBrandFooter,
    AdvanceTestTemplate,
    NavbarTest,
    YEMSQPlusInterpretation,
    MentalReadinessForChangeInterpretation,
    NeoInterpretation,
    DisappointmentBeckInterpretation,
    BodyShamingInterpretation,
    QolInterpretation,
    GeneralInterpretation,
    SexualFunctionInterpretation,
    BeckInterpretation,
    Tpcinterpretation,
    SclInterpretation,
    StlsInterpretation
  },
  created() {
    this.getInterpretation()
  },
  data() {
    return {
      interpretations: [
        {
          id: '1',
          component: 'BeckInterpretation'
        },
        {
          id: '3',
          component: 'sclInterpretation'
        },
        {
          id: '4',
          component: 'Tpcinterpretation'
        },
        {
          id: '7',
          component: 'StlsInterpretation'
        },
        {
          id: '8',
          component: 'SexualFunctionInterpretation'
        }
      ],
      templates: [
        {
          name: 'General',
          component: 'GeneralInterpretation'
        },
        {
          name: "sclTemplate",
          component: 'sclInterpretation',
        },
        {
          name: "beckTemplate",
          component: 'BeckInterpretation'
        },
        {
          name: 'tcpTemplate',
          component: 'Tpcinterpretation',
        },
        {
          name: 'StlsTemplate',
          component: 'StlsInterpretation'
        },
        {
          name: 'QolInterpretation',
          component: 'QolInterpretation'
        },
        {
          name: "BodyShaming",
          component: "BodyShamingInterpretation",
        },
        {
          name: "DisappointmentTest",
          component: "DisappointmentBeckInterpretation",
        },
        {
          name: "NeoInterpretation",
          component: 'NeoInterpretation'
        },
        {
          name: "MRFC",
          component: 'MentalReadinessForChangeInterpretation'
        },
        {
          name: "YEMSQ",
          component: 'YEMSQPlusInterpretation'
        },
        {
          name: "advanceTestTemplate",
          component: 'AdvanceTestTemplate'
        },
      ],
      report: null,
      run_id: null,
      run_attemp: 10,
      ai_response: null,

    }
  },
  mixins: [EventsMixins],
  computed: {
    testTarget() {
      return this.interpretations.find(item => item.id == this.$route.params.testID)
    },
    targetTemplate() {
      if (this.report) {
        return this.templates.find(item => item.name == this.report.test.template.name)
      }
      return null
    },
    journeyLang() {
      return this.$route.params.lang || 'fa'
    },
    ...mapGetters({
      'isLoggedIn': 'getIsLoggedIn',
      'profile': 'getProfile'
    })
  },
  methods: {
    registerOrTestPanel() {
      if (this.isLoggedin) {
        this.$router.push({name: "tests"})
      } else {
        this.$emitEvent('openModalRegister')
      }
    },
    getInterpretation() {
      this.requesting('test', 'getInterpretation', {
            'userTestID': this.$route.params.userTestId,
            'testID': this.$route.params.testID,
          }
      ).then((resp) => {
        this.report = resp.data[0]

        const testScore = this.getMainZoneScore(this.report)
        if (testScore != null) {
          this.SendEventTrk({
            event_id: 'psychological_test_' + this.$route.params.testID + '_' + this.$route.params.userTestId,
            name: 'psychological_test',
            email: this.profile.email,
            first_name: this.profile.firstname,
            last_name: this.profile.lastname,
            payload: {
              test_score: testScore,
              test_id: this.$route.params.testID,
              user_test_id: this.$route.params.userTestId,
            }
          })
        }

        if (this.report.ai_response) {
          try {
            this.ai_response = JSON.parse(this.report.ai_response)
          } catch (e) {
            this.ai_response = null
          }
        }
        if (resp.data[0].hasOwnProperty('guest_participant_id')) {
          this.$store.dispatch('setGuestParticipantId', resp.data[0].guest_participant_id)
        }
      });
    },
    getAiData() {
      this.ai_response = 'loader'
      this.requesting('test', 'sendDataToAi', {}, {
        'message': 'در تست استاندارد افسردگی بک نمره ی ' + this.report.result[0].score.sum + ' گرفته ام ',
        "assistant_id": 47,
        'run': true,
      }).then((resp) => {
        this.run_id = resp.data.run.gpt_run_id
        setTimeout(() => {
          this.getRunData()
        }, 2000)
      })
    },
    goToTop() {
      window.scrollTo({
        top: 0
      });
    },
    getRunData() {
      this.run_attemp--
      if (this.run_attemp != 0) {
        this.requesting('test', 'getResponseAi', {}, {
          "run_gpt_id": this.run_id,
        }).then((resp) => {
          if (resp.data.run.status == 'completed') {
            this.ai_response = JSON.parse(resp.data.message)
            this.storeAiResoinseOnInterpretation()
          } else {
            setTimeout(() => {
              this.getRunData()
            }, 2000)
          }
        })
      }
    },
    storeAiResoinseOnInterpretation() {
      this.requesting('test', 'storeAiResponse', {
        'userTestId': this.$route.params.userTestId,
        'testId': this.$route.params.testID,
      }, {
        ai_response: JSON.stringify(this.ai_response)
      }).then((resp) => {
        console.log(resp, '12121')
      })
    }
  },
}
</script>

<style scoped>
@media (min-width: 200px ) and (max-width: 600px) {
  .footerContent {
    width: 80% !important;
  }
}


.interpretationArea {
  /*position: relative;*/
  min-height: 100vh;
  overflow-x: hidden;
}


.circleOne {
  background: #dff8ff;
  z-index: 0 !important;
  width: 800px;
  height: 800px;
  border-radius: 50%;
  top: -300px;
  left: -300px;
  position: absolute;
  filter: blur(20px);
}

.circlefour {
  background: #dff8ff;
  z-index: 0;
  width: 850px;
  height: 850px;
  border-radius: 50%;
  bottom: 0px;
  right: -200px;
  position: absolute;
  filter: blur(20px);
}

.circleTwo {
  position: absolute;
  background: #f0f1ff;
  top: 600px;
  left: -140px;
  width: 450px;
  height: 450px;
  border-radius: 50%;
  filter: blur(20px);
}

.circleThree {
  position: absolute;
  background: #e0fff6;
  top: 200px;
  right: -150px;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  filter: blur(20px);
}

.interpretationContent {
  /*position: absolute;*/
  margin-top: 100px;
  z-index: 10 !important;
  position: relative;
}

.interpretationCta {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: none;
  margin: 40px 0 48px;
  padding: 40px 24px 36px;
  border-radius: 0;
  //box-shadow: 0 3px 25px 0 rgba(0, 0, 0, 0.06);
}

.interpretationCta__title {
  margin: 0 0 24px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.6;
  color: #212121;
}

.interpretationCta__link {
  text-decoration: none;
  display: inline-block;
}

.interpretationCta__btn {
  min-width: 220px !important;
  height: 52px !important;
  border-radius: 10px !important;
  font-size: 17px !important;
}

@media (max-width: 600px) {
  .interpretationCta {
    width: 100%;
    margin-bottom: 32px;
    padding: 32px 16px 28px;
  }

  .interpretationCta__title {
    font-size: 17px;
  }

  .interpretationCta__btn {
    min-width: 100% !important;
  }
}

.footer {
  position: relative;
  z-index: 10;
}

.footerContent {
  width: 60%;
  margin: 0px auto;
}

.footerItem > .footerItemTitle {
  font-size: 19px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  /*line-height: 2.57;*/
  letter-spacing: normal;
  text-align: right;
  color: #b9b9b9;
  margin-bottom: 10px;
}

.footerItem > .footerItemContent {
  font-size: 12px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: right;
  color: #6d6d6d;
}

.linkExternal {
  text-decoration: none;
  color: inherit;
  transition: all 0.3s;
}

.linkExternal:hover {
  color: #000000;
  transition: all 0.3s;
}

.footerSubTitle {
  color: #6d6d6d;
}

.termsBtn {
  width: 122px !important;
  height: 27px !important;
  background-color: #46b1a1 !important;
  border-radius: 10px 10px 0px 0px !important;
}

a {
  text-decoration: none;
}
</style>